// extracted by mini-css-extract-plugin
export var icon = "_b-1";
export var subtext = "_b-0";